//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";
import QueryPanel from "./components/query/QueryPanel";
import FilterList from "./components/query/FilterList";
import Results from "./components/results/Results";
import Sorting from "./components/query/Sorting";
import SearchBar from "./components/query/SearchBar";

export default {
  name: "Search",
  props: {
    queryText: String,
  },
  components: {
    appQueryPanel: QueryPanel,
    appResults: Results,
    appFilterList: FilterList,
    appSorting: Sorting,
    appSearchBar: SearchBar,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getTotal", "isArchive"]),
  },
  methods: {
    ...mapMutations(["setQueryText"]),
    ...mapActions([
      "search",
      "loadFilters",
      "loadYears",
      "loadQuery",
      "toggleFilter",
      "changeSection",
      "clearFilters",
      "showFilters",
    ]),
  },
  async created() {
    this.setQueryText(this.queryText);

    await this.loadQuery();
    await this.loadFilters();
    await this.loadYears();
    await this.search();
  },
};
